<template>
    <div>
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-radio-group
                    label="Jornada"
                    v-model="model.escala.jornadaEmHoras"
                    :options="form.jornadas"
                    :validations="validations.jornadas"
                    buttons
                    button-color="outline-primary"
                    name="radioJourney"
                    :disabled="disabled"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-radio-group
                    label="Descanso"
                    v-model="model.escala.descanso"
                    :validations="validations.descanso"
                    :options="form.descansos"
                    buttons
                    button-color="outline-primary"
                    name="radioRest"
                    :disabled="disabled"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-input
                    label="Número de atendimentos"
                    number
                    v-model="model.escala.quantidadeAtendimentos"
                    :validations="validations.quantidadeAtendimentos"
                    :disabled="disabled"
                />
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
export default {
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        disabled: { type: Boolean, default: false },
    },
    computed: {
        validations() {

            return {
                jornadas: { required: true },
                descanso: { required: true },
                quantidadeAtendimentos: { required: true, max: 8 }
            }
        }
    },
    watch: {
        'model.escala.jornadaEmHoras': function() {

            this.form.descansos.map(d => d.disabled = true)

            let index = this.form.jornadas.findIndex(j => j.value === this.model.escala.jornadaEmHoras)

            if (index >= 0) {

                if (index === 0) {

                    index = 1
                }
                else if (index === 1) {

                    index = 0
                }

                this.form.descansos[index].disabled = false
                this.model.escala.descanso = this.form.descansos[index].value
            }
        }
    },
}
</script>